export default __webpack_public_path__ + "static/media/header-card.6be2e229.svg";